module.exports = __webpack_public_path__ + "img/markImages-Icon-gray.f05ea70c.svg";